<ng-container *ngIf="!isMobileView; else mobileTemplate">
  <div>
    <image-loader-utils extraClasses="desktop_logo" [url]="this.selectedBonusModal?.imageDesktopUrlName" [shared]="false" [imageFormat]="'png'"></image-loader-utils>
  </div>
  <div class="bonus-info-container">
    <div class="header-bold">{{ this.selectedBonusModal?.headerText }}</div>
    <div class="text-row">{{ this.selectedBonusModal?.headerDescription }}</div>
    <ng-container>
      <div class="button-container" (click)="onNoClick()">
        <div class="btn colored green save-changes-button confirm-button">
          <div class="btn-text">
            {{ this.selectedBonusModal?.btnText }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
<ng-template #mobileTemplate>
  <div>
    <image-loader-utils extraClasses="desktop_logo" [url]="this.selectedBonusModal?.imageMobileUrlName" [shared]="false" [imageFormat]="'png'"></image-loader-utils>
  </div>
  <div class="bonus-info-container">
    <div class="header-bold">{{ this.selectedBonusModal?.headerText }}</div>
    <div class="text-row">{{ this.selectedBonusModal?.headerDescription }}</div>
    <ng-container>
      <div class="button-container" (click)="onNoClick()">
        <div class="btn colored green save-changes-button confirm-button">
          <div class="btn-text">
            {{ this.selectedBonusModal?.btnText }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>
